












import { defineComponent } from '@vue/composition-api';

const ExpandButton = defineComponent({
  props: {
    value: { type: Boolean },
    color: { type: String, default: 'primary-500' },
  },
  // setup() {
  // },
});

export default ExpandButton;
